/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for a ventilation stack.
 */
export type AnimaticVentilationStackConfig = {};

/** @internal */
export const AnimaticVentilationStackConfig$inboundSchema: z.ZodType<
  AnimaticVentilationStackConfig,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AnimaticVentilationStackConfig$Outbound = {};

/** @internal */
export const AnimaticVentilationStackConfig$outboundSchema: z.ZodType<
  AnimaticVentilationStackConfig$Outbound,
  z.ZodTypeDef,
  AnimaticVentilationStackConfig
> = z.object({});

export function animaticVentilationStackConfigToJSON(
  animaticVentilationStackConfig: AnimaticVentilationStackConfig,
): string {
  return JSON.stringify(
    AnimaticVentilationStackConfig$outboundSchema.parse(
      animaticVentilationStackConfig,
    ),
  );
}
export function animaticVentilationStackConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticVentilationStackConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticVentilationStackConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticVentilationStackConfig' from JSON`,
  );
}
